// extracted by mini-css-extract-plugin
export var aircallIframe = "_lm-3";
export var fabContainer = "_lm-5";
export var fabRinging = "_lm-6";
export var loadingOverlay = "_lm-4";
export var pulse = "_lm-7";
export var widgetContent = "_lm-2";
export var widgetPanel = "_lm-0";
export var widgetPanelExpanded = "_lm-1";